import HoldingReportsActions from "../../../../redux/actions/Reports/HoldingReport";
import DashboardHoldingSummaryActions from "../../../../redux/actions/Reports/DashboardHoldingSummary";
export const DashBoardActions = new DashboardHoldingSummaryActions();
export default () => {
    return new HoldingReportsActions();
};
